import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import EntityTypes from '../../types/EntityTypes';
import { NoteIcon } from '../../components/Icons';
import renderInlines from '../utils/renderInlines';
import { normalizeNode, shouldHaveText } from '../utils/NormalizationHelper';
import NoteLink from './components/NoteLink';
import PublicNoteLink from './components/PublicNoteLink';
import serializers from './serializers';
import makeToolbarButton, { EXPANDED_INSERTION, BASIC_INSERTION } from '../utils/makeToolbarButton';
import './style.css';
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isPublic = _ref.isPublic,
      _ref$decorator = _ref.decorator,
      decorator = _ref$decorator === void 0 ? function (x) {
    return x;
  } : _ref$decorator;

  // * Example for decorators
  var Component = isPublic ? decorator(PublicNoteLink) : decorator(NoteLink);
  return [normalizeNode(EntityTypes.NOTELINK, [shouldHaveText]), {
    serializers: serializers
  }, renderInlines(_defineProperty({}, EntityTypes.NOTELINK, function (props, editor, next) {
    var attributes = props.attributes,
        node = props.node;
    var noteId = node.data.get('noteId');
    var blockId = node.data.get('blockId');
    var notFound = node.data.get('notFound');
    return React.createElement(Component, Object.assign({
      noteId: noteId,
      blockId: blockId,
      notFound: notFound
    }, props, attributes));
  })), makeToolbarButton(EntityTypes.NOTELINK, {
    icon: NoteIcon,
    title: 'Link to doc',
    visibility: // TODO: Add note link on selection before allowing those
    // BASIC_SELECTION |
    BASIC_INSERTION | // EXPANDED_SELECTION |
    EXPANDED_INSERTION,
    onApply: function onApply(editor) {
      return editor.insertText('@').command('openNoteLinkPicker');
    }
  })];
});